import React from 'react'
import Icon from './Icon'

export default ({
  prefix,
  register,
  bgWhite,
  boderRaiusNone,
  isCode,
  title,
  hint,
  errMsg,
  isPass,
  icon,
  children,
}) => {
  const style = boderRaiusNone
    ? { borderBottom: '1px solid #edf2f5', borderRadius: '0' }
    : {}
  return (
    <div
      className={
        bgWhite
          ? `${prefix}-inputPwdBox input-text`
          : `${prefix}-inputPhoneBox input-text`
      }
      style={bgWhite ? style : {}}
    >
      <Icon
        width="19"
        className={`${prefix}-inputIcon`}
        style={{ margin: '0 20px' }}
        path={icon}
      />
      <div
        className={
          isCode
            ? 'w-1/2 h-4/5 flex flex-col justify-between'
            : 'flex-1 h-4/5 flex flex-col justify-between'
        }
      >
        <h1 className={`${prefix}-inputTitle`}>{title}</h1>
        <input
          autoComplete="off"
          {...register()}
          className={`${prefix}-inputPhone login-input phone`}
          placeholder={hint}
        />

        {errMsg && <span className="text-red-1 mt-1">{errMsg}</span>}
      </div>
      {children}
      {isPass && !children && (
        <Icon
          width="15"
          className={`${prefix}-inputPass`}
          path="M512 1024C229.230592 1024 0 794.769408 0 512S229.230592 0 512 0s512 229.230592 512 512-229.230592 512-512 512zM254.12608 528.77312l172.396544 174.733312a0.607232 0.607232 0 0 0 0.864256 0.01536l342.540288-343.36768a0.311296 0.311296 0 0 0-0.003072-0.44032l-37.359616-37.285888a0.320512 0.320512 0 0 0-0.443392-0.02048l-304.47616 277.743616c-0.37376 0.340992-0.996352 0.357376-1.381376 0.027648L294.8608 487.48544a0.339968 0.339968 0 0 0-0.452608 0.022528l-40.27904 40.824832a0.3072 0.3072 0 0 0-0.004096 0.44032z"
        />
      )}
    </div>
  )
}
